"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../../styled-components");
const Base_1 = require("../Base");
const StyledWrapper = styled_components_1.styled.div `
  position: absolute;
  top: 9px;
  left: ${({ left }) => (left ? `${left}px` : "5px")};
  opacity: 1;
`;
const MagnifyingGlass = ({ size = 16, fill, name, left, ...rest }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(StyledWrapper, { left: left },
        react_1.default.createElement(Base_1.Base, { size: size, fill: fill !== null && fill !== void 0 ? fill : theme.icon, smooth: true, ...rest },
            react_1.default.createElement("title", null, name),
            react_1.default.createElement("path", { d: "M5.8,8.7L1.1,13.3l1.4,1.4,4.7-4.6c1.9,1.3,4.6,1.1,6.3-.6,1.9-2,2-5.2,0-7.1s-5.2-1.9-7.1,0c-1.7,1.7-1.9,4.3-.6,6.3ZM7.9,3.8c1.1-1.2,3-1.1,4.2,0s1.1,3,0,4.2-3,1.2-4.2,0c-1.2-1.2-1.1-3,0-4.2Z" }))));
};
exports.default = MagnifyingGlass;
//# sourceMappingURL=index.js.map